'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var context = require('@andes/context');
var warning = require('@andes/common/build/utils/warning');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
const WARNING_CSRF = "To prevent CSRF attacks, <Form> needs a csrf token. Please, provide one in <AndesProvider> via <csrfToken> prop.\nRefer to https://github.com/melisource/fury_frontend-andes-ui/tree/master/packages/form#csrf-protection-by-default for more details.";
const _excluded = ["children"];
const Form = /*#__PURE__*/function () {
  const Form = _ref => {
    let {
        children
      } = _ref,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);
    const {
      csrfToken
    } = React.useContext(context.AndesContext);
    const [metaCsrfToken, setMetaCsrfToken] = React.useState(null);
    const inputValue = csrfToken || metaCsrfToken;
    React.useEffect(() => {
      if (!csrfToken) {
        const metaTag = document.querySelector('meta[name=csrf-token]');
        if (metaTag) {
          setMetaCsrfToken(metaTag.getAttribute('content'));
        }
      }
    }, [csrfToken]);
    warning__default["default"](csrfToken, WARNING_CSRF);
    return /*#__PURE__*/React__default["default"].createElement("form", props, inputValue && /*#__PURE__*/_jsx__default["default"]("input", {
      type: "hidden",
      name: "_csrf",
      value: inputValue
    }), children);
  };
  Form.displayName = 'Form';
  return Form;
}();
var Form$1 = Form;
exports.Form = Form$1;
exports["default"] = Form$1;
